// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8106":"3af4b431","9622":"66348ed7"}[chunkId] + ".chunk.css";
};